import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getAnswer, getOptions } from '../utils';

const useStyles = makeStyles({
  questionText: {
    fontFamily: 'Lato !important',
    fontWeight: '600 !important',
    fontSize: '12px !important',
    color: '#10182B !important',
  },
  answerText: {
    width: '100%',
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-all',
    fontSize: '12px !important',
    color: '#667085 !important',
  },
  answerTextSpaced: {
    marginTop: '6px !important',
  },
  scrollContainer: {
    maxHeight: '70vh',
    width: '45vw',
    overflowY: 'auto',
    paddingRight: '16px',
  },
});

const QuizAccordian = () => {
  const classes = useStyles();
  const overview = useSelector((state) => state?.getQuiz?.quizDetails);
  const [expandedPanel, setExpandedPanel] = React.useState(0);

  const handleChange = (index) => (_event, isExpanded) => {
    setExpandedPanel(isExpanded ? index : null);
  };

  return (
    <div className={classes.scrollContainer}>
      {overview?.questions?.map((q, i) => (
        <Accordion
          expanded={expandedPanel === i}
          onChange={handleChange(i)}
          sx={{
            border: '1px solid #E4E7EC',
            borderRadius: '8px',
            boxShadow: 'none',
            transform: 'none',
            marginTop: '16px',
          }}
        >
          <AccordionSummary
            aria-controls={`panel${i}-content`}
            id={`panel${i}-header`}
            expandIcon={
              <ChevronRightIcon
                style={{
                  color: '#10182B',
                  marginRight: '16px',
                  transform: expandedPanel === i ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                }}
              />
            }
            sx={{
              minHeight: '56px',
              paddingY: 0,
              paddingX: '16px',
              flexDirection: 'row-reverse',
              overflow: 'hidden',
              '& .MuiAccordionSummary-expandIconWrapper': {
                transform: 'none !important',
                marginRight: 'auto',
                marginLeft: 0,
              },
              '&.Mui-expanded': {
                minHeight: '48px',
              },
              '& .MuiAccordionSummary-content': {
                margin: 0,
                minWidth: 0,
                overflow: 'hidden',
              },
            }}
          >
            <Typography
              component="div"
              className={classes.questionText}
              sx={{
                display: 'block',
                width: '100%',
                minWidth: 0,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-all',
              }}
            >
              {q.title}
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              paddingTop: '2px',
              paddingBottom: '8px',
              marginLeft: '40px',
              fontFamily: 'Lato',
              fontWeight: 500,
            }}
          >
            <Typography component="div" className={classes.answerText}>
              Options: {getOptions(q.options)}
            </Typography>
            <Typography component="div" className={`${classes.answerText} ${classes.answerTextSpaced}`}>
              Correct Answer: {getAnswer(q.options)}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default QuizAccordian;
